export default __webpack_public_path__ + "static/media/group-94.78bb3dac.svg";